export default "__VITE_ASSET__c7429a74__"